var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDinosaur = function SvgDinosaur(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 285,
    height: 306,
    viewBox: "13 0 285 306",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    fillRule: "evenodd",
    transform: "translate(13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fill: "#666",
    d: "M256.35 91.664h-42.43V80.039h70.57v-65.73H270.2V0H155.4v14.309h-13.85v91.661h-14.29v13.86h-20.99v14.31H85.271v14.31H70.977v13.86H45.069V148H31.222v-13.86H16.928v-28.17H.848v86.75h13.847v14.31h14.293v13.86h13.848v14.31H57.13v13.86h13.847v56.34h30.373v-16.1H87.504v-12.07h13.846v-13.86h14.3v-14.31h11.61v14.31h14.29v42.03h30.38v-16.1h-14.3v-54.1h14.3v-14.31h13.85v-21.02h14.29v-49.18h11.61v13.86h16.53v-30.41h-28.14v-25.93h56.28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    fill: "#fff",
    d: "M169.25 20.569h16.974V37.56H169.25z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDinosaur);
export default ForwardRef;